module.exports = __webpack_public_path__ + "assets/img/W3-1-F.0c57790f.png";